import { useCallback, useEffect, useState } from 'react';
import { Plus, Search } from 'lucide-react';
import { api } from '../../api';
import { pode, useSessao } from '../../sessao';
import { real } from './comum';

interface Servico { id: string; sku: string | null; nome: string; descricao: string | null; unidade: string; preco: string | null; ativo: boolean; versao: number }

/** Catálogo de serviços com preço (mão de obra, visita, configuração…). O técnico usa no orçamento pelo app. */
export function Servicos() {
  const { usuario } = useSessao();
  const podeEditar = pode(usuario, 'servicos.editar');
  const [busca, setBusca] = useState('');
  const [lista, setLista] = useState<Servico[] | null>(null);
  const [inativos, setInativos] = useState(false);
  const [erro, setErro] = useState<string | null>(null);
  const [edit, setEdit] = useState<Record<string, { nome: string; preco: string; unidade: string }>>({});
  const [novo, setNovo] = useState({ nome: '', preco: '', unidade: 'serv' });

  const carregar = useCallback(() => {
    const q = new URLSearchParams(); if (busca.trim()) q.set('busca', busca.trim()); if (inativos) q.set('inativos', 'true');
    api<Servico[]>(`/servicos?${q}`).then(setLista).catch((e) => setErro(e.message));
  }, [busca, inativos]);
  useEffect(() => { const t = setTimeout(carregar, 250); return () => clearTimeout(t); }, [carregar]);
  const num = (t: string) => Number(t.replace(/\./g, '').replace(',', '.'));

  async function criar() {
    setErro(null);
    try { await api('/servicos', { metodo: 'POST', corpo: { nome: novo.nome.trim(), preco: num(novo.preco), unidade: novo.unidade || 'serv' } }); setNovo({ nome: '', preco: '', unidade: 'serv' }); carregar(); }
    catch (e) { setErro(e instanceof Error ? e.message : 'Não foi possível criar.'); }
  }
  async function salvar(s: Servico, mudanca: Record<string, unknown>) {
    setErro(null);
    try { await api(`/servicos/${s.id}`, { metodo: 'PATCH', corpo: { versao: s.versao, ...mudanca } }); setEdit((e) => { const n = { ...e }; delete n[s.id]; return n; }); carregar(); }
    catch (e) { setErro(e instanceof Error ? e.message : 'Não foi possível salvar.'); }
  }

  return (
    <>
      <div className="barra-filtros">
        <label className="campo-busca"><Search size={18} strokeWidth={1.7} aria-hidden /><input type="search" placeholder="Buscar serviço" value={busca} onChange={(e) => setBusca(e.target.value)} /></label>
        <label className="check"><input type="checkbox" checked={inativos} onChange={(e) => setInativos(e.target.checked)} /> Mostrar desativados</label>
      </div>
      {erro && <p className="alerta" role="alert">{erro}</p>}
      {podeEditar && (
        <div className="cartao form" style={{ marginBottom: 16 }}>
          <div className="linha-3-igual">
            <label>Serviço<input value={novo.nome} onChange={(e) => setNovo({ ...novo, nome: e.target.value })} placeholder="Ex.: Mão de obra técnica (hora)" maxLength={200} /></label>
            <label>Preço (R$)<input inputMode="decimal" value={novo.preco} onChange={(e) => setNovo({ ...novo, preco: e.target.value })} placeholder="180,00" /></label>
            <label>Unidade<input value={novo.unidade} onChange={(e) => setNovo({ ...novo, unidade: e.target.value })} maxLength={10} placeholder="h, visita, serv" /></label>
          </div>
          <div className="acoes-form"><button className="btn" disabled={novo.nome.trim().length < 2 || !(num(novo.preco) >= 0) || !novo.preco} onClick={criar}><Plus size={18} aria-hidden /> Incluir serviço</button></div>
        </div>
      )}
      {lista && (lista.length === 0 ? <p className="nota">Nenhum serviço cadastrado ainda.</p> : (
        <div className="cartao tabela-cartao rolagem-x">
          <table className="tabela">
            <thead><tr><th>Serviço</th><th>Unidade</th><th className="num">Preço</th>{podeEditar && <th></th>}</tr></thead>
            <tbody>
              {lista.map((s) => {
                const e = edit[s.id];
                return (
                  <tr key={s.id} className={s.ativo ? '' : 'inativo'}>
                    <td>{e ? <input value={e.nome} onChange={(x) => setEdit({ ...edit, [s.id]: { ...e, nome: x.target.value } })} /> : <strong>{s.nome}</strong>}</td>
                    <td>{e ? <input value={e.unidade} onChange={(x) => setEdit({ ...edit, [s.id]: { ...e, unidade: x.target.value } })} style={{ width: 90 }} /> : s.unidade}</td>
                    <td className="num">{e ? <input inputMode="decimal" value={e.preco} onChange={(x) => setEdit({ ...edit, [s.id]: { ...e, preco: x.target.value } })} style={{ width: 110, textAlign: 'right' }} /> : real(s.preco)}</td>
                    {podeEditar && <td className="acoes-linha">
                      {e ? <>
                        <button className="btn-link" onClick={() => salvar(s, { nome: e.nome.trim(), unidade: e.unidade.trim() || 'serv', preco: num(e.preco) })}>salvar</button>
                        <button className="btn-link" onClick={() => setEdit((x) => { const n = { ...x }; delete n[s.id]; return n; })}>cancelar</button>
                      </> : <>
                        <button className="btn-link" onClick={() => setEdit({ ...edit, [s.id]: { nome: s.nome, unidade: s.unidade, preco: Number(s.preco ?? 0).toFixed(2).replace('.', ',') } })}>editar</button>
                        <button className="btn-link" onClick={() => salvar(s, { ativo: !s.ativo })}>{s.ativo ? 'desativar' : 'reativar'}</button>
                      </>}
                    </td>}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ))}
    </>
  );
}
